<template>
  <m-card208 :image="product.thumbnail" :alt="product.name">
    <template #p-1>
      <h4 class="mt-1 mr-2 price-card-description">
        {{ product.name }}
      </h4>
      <div class="d-block mr-2 price-card-title" v-html="product.description">
      </div>
    </template>
    <template #p-2>
      <div class="col-12 price-card-title pb-2 px-0">
        <template v-if="product.variation == 1" v-for="feature in productFeatureSubProduct(product)">
          <ProductCard208PriceManager class="product-card-200-price-manager-wrapper"
                                      show-trash-only-in-first-quantity="true"
                                      :product="product"
                                      :feature="feature"/>
        </template>
        <ProductCard208PriceManager show-trash-only-in-first-quantity="true"
                                    class="product-card-200-price-manager-wrapper" v-else :product="product"/>
      </div>
    </template>
  </m-card208>
</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import mA from '../../../Tags/A.vue'
import mImg from '../../../Tags/Img.vue'
import {OfferProps} from "../../../Product/ProductOffer/ProductOfferProps";
import ProductCardQuantityManager1 from "./../ProductCard208/ProductCard208PriceManager.vue";
import VariationProduct from "./../../SingleProductPrice3/VariationProduct.vue";
import {productFeatureName, productFeatureSubProduct} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product'
import mShoppingCartQuantityManager1 from "../../ShoppingCartQuantityManager1.vue";
import ProductCardPrice200 from "./../../ProductCardPrice200/ProductCardPrice200.vue";
import SingleProductPrice3 from "./../../SingleProductPrice3/SingleProductPrice3.vue";
import ProductCard208PriceManager from "../ProductCard208/ProductCard208PriceManager.vue";
import mCard208 from "../../../Cards/Card208.vue";

export default {
  name: "ProductCard208",
  components: {
    ProductCard208PriceManager,
    SingleProductPrice3,
    ProductCardPrice200,
    mShoppingCartQuantityManager1,
    VariationProduct,
    ProductCardQuantityManager1,
    mA,
    mImg,
    mCard208
  },
  props: {
    product: {},
    ...OfferProps,
  },
  data() {
    return {
      selectedVariation: null,
      selectedVariationObject: {},
    }
  },
  methods: {
    formatNumber,
    productFeatureName,
    productFeatureSubProduct,
    selectVariation(product, feature) {
      this.selectedVariation = feature.id
      this.selectedVariationObject = feature
    },
  },
}

</script>

<style scoped>



.price-card-title {
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1rem;
  width: auto;
  height: auto;
  display: inline-block;
  color: rgb(58, 61, 66);
  text-align: initial;
}

.price-card-description {
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1.25rem;
  width: auto;
  height: auto;
  display: inline-block;
  color: rgb(58, 61, 66);
  text-align: initial;
}

.product-card-200-price-manager-wrapper{
  margin: 12px 0;
}
.product-card-200-price-manager-wrapper :deep(.show-price-wrapper .product-single .normal-product-shopping-card-link) {
  display: none !important;
}

.product-card-200-price-manager-wrapper :deep(.show-price-wrapper .product-single .normal-product-button-section .normal-product-button-main) {
  padding-right: 3rem;
  padding-left: 3rem;
}

</style>